import { AnalyticsSender, Offer } from '@funtech-int/yango-shared';

import {
    OnboardingPlusSubscriptionOfferNavigatedV5To,
    onboardingPlusSubscriptionOfferNavigatedV5,
    onboardingPlusSubscriptionOfferShowedV5,
    onboardingPlusSubscriptionOfferSucceedV4,
} from '@kinopoisk-int/evgen-web-events/web/onboarding_plus';
import { OnboardingPlusOfferEntityType } from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { TARIFFICATOR_BILLING_PRODUCT_ID } from '@/shared/lib/analytics/offer';
import { getOfferTitle } from '@/shared/lib/analytics';

interface OfferAnalyticsParams {
    buttonText: string;
    offer: Offer;
    entityType?: string;
}

interface OfferAnalytics {
    showed(this: void): void;
    navigated(this: void): void;
    succeeded(this: void): void;
}

export function createOfferAnalytics(
    eventSender: AnalyticsSender,
    { buttonText, entityType, offer }: OfferAnalyticsParams
): OfferAnalytics {
    const offerTariffName = offer.catalogCompositeOffer.tariffOffer?.tariff?.name ?? '';
    const offerOptionNames = offer.catalogCompositeOffer.optionOffers?.[0]?.option?.name ?? '';

    const commonData = {
        buttonText,
        offerTitle: getOfferTitle(offer),
        offerTariffName,
        offerOptionNames,
        billingProductId: TARIFFICATOR_BILLING_PRODUCT_ID,
        billingProductIds: offer.billingProductIds,
    };

    return {
        showed() {
            eventSender.sendOnce(onboardingPlusSubscriptionOfferShowedV5, {
                ...commonData,
                show: offer.offerPositionsData,
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
            });
        },
        navigated() {
            eventSender.send(onboardingPlusSubscriptionOfferNavigatedV5, {
                ...commonData,
                click: offer.offerPositionsData,
                entityType: OnboardingPlusOfferEntityType.SubscriptionOption,
                to: OnboardingPlusSubscriptionOfferNavigatedV5To.Payment,
            });
        },
        succeeded() {
            eventSender.send(onboardingPlusSubscriptionOfferSucceedV4, {
                ...commonData,
                entityType: entityType
                    ? (entityType as OnboardingPlusOfferEntityType)
                    : OnboardingPlusOfferEntityType.SubscriptionOption,
            });
        },
    };
}
